import {
    ALL_CATEGORIES,ALL_MERCHANTS
} from '../cms-actions/types'

const INITIAL_STATE = {
    allCategories:[],
    allMerchants:[]
}
const rootReducers1 = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ALL_CATEGORIES: {
            return {
                ...state,
                allCategories: action.payLoad
            }
        }
        case ALL_MERCHANTS: {
            return {
                ...state,
                allMerchants: action.payLoad
            }
        }
        default: {
            return {
                ...state
            }
        }
    }
}

export default rootReducers1;